import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@material-ui/core/styles';

  // customize style for border color of input base
  const useStyles = makeStyles(() => ({
    focused: {
      "& .Mui-focused": {
        border: 'border: 0.91px solid #0B5FFF'
      }
    },
    input: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      "& ::placeholder": {
        fontFamily: 'Poppins',
        color: "#000000",
        fontSize: '16px',
        opacity: 1,
        fontweight: 600,
      }
    }
  }));

export default function CustomizedInputBase({ searchValue, changeEvent, handleSearch }) {

    const classes = useStyles();
    const [inputFocused, setInputFocused] = React.useState(false);

    const changeHandle = (e) => {
      changeEvent(e.target.value);
    }

    const handleSearchIconClick = (e) => {
      e.preventDefault();
      handleSearch(searchValue);
    }

    const handleClick = () => {
      setInputFocused(true);
    }


  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, height: '45px', border: `${inputFocused ? '0.91px solid #0B5FFF' : '0.91px solid #E1EEF9'}`, borderRadius: '910.747px', boxShadow: 'none' }}
    >
      <InputBase
        sx={{ ml: 2, flex: 1 }}
        placeholder="Search"
        inputProps={{ 'aria-label': 'search google maps'}}
        onChange={changeHandle}
        value={searchValue}
        classes={classes.focused}
        className={classes.input}
        onClick={handleClick}
        onBlur={() => setInputFocused(false)}
      />
      <IconButton style={{backgroundColor : '#0B5FFF', color: 'white'}} onClick={handleSearchIconClick} type="submit" sx={{ p: '8px', m:'5px' }} aria-label="search">
        {/* <SearchIcon /> */}
        <img src="./search.svg" alt="Search Icon" />
      </IconButton>
    </Paper>
  );
}